import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { useIntl } from "react-intl";
import "./scss/styles.scss";
import { useAuth } from "@saleor/sdk";
import { isEqual } from "lodash";
import classNames from "classnames";
import { useLocation } from "react-router-dom";
import { IconButton, Loader } from "@components/atoms";
import { commonMessages, errorMessage, settingsMessages } from "@temp/intl";
import { AccountErrorCode } from "@saleor/sdk/lib/gqlTypes/globalTypes";
import * as S from "../../@next/components/molecules/AccountTabTiles/styles";
import { AlertReusableDialog } from "../../components/AlertReusableDialog";
export var NotificationPreferences = function NotificationPreferences() {
  var _location$state2, _user$currentTrade3;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      loading = _React$useState2[0],
      setLoading = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isEditing = _React$useState4[0],
      setIsEditing = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      showAlert = _React$useState6[0],
      setShowAlert = _React$useState6[1];

  var _React$useState7 = React.useState({
    title: "",
    description: ""
  }),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      alertMessages = _React$useState8[0],
      setAlertMessages = _React$useState8[1];

  var intl = useIntl();

  var _useAuth = useAuth(),
      user = _useAuth.user,
      addNotificationBlacklist = _useAuth.addNotificationBlacklist,
      removeNotificationBlacklist = _useAuth.removeNotificationBlacklist;

  var _React$useState9 = React.useState({
    allTrades: false,
    currentTrade: false
  }),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      notificationOptionOld = _React$useState10[0],
      setNotificactionOptionOld = _React$useState10[1];

  var _React$useState11 = React.useState({
    allTrades: false,
    currentTrade: false
  }),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      notificationOption = _React$useState12[0],
      setNotificactionOption = _React$useState12[1];

  var location = useLocation();
  var myComponentRef = React.useRef(null);

  var handleAddToBlacklist = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _user$currentTrade;

      var maintradeId, response, _response, _response$data, _response$data$errors, _response2, _response2$data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              maintradeId = +atob(user === null || user === void 0 ? void 0 : (_user$currentTrade = user.currentTrade) === null || _user$currentTrade === void 0 ? void 0 : _user$currentTrade.idMainTrade).split(":")[1];
              _context.prev = 2;

              if (!notificationOption.allTrades) {
                _context.next = 9;
                break;
              }

              _context.next = 6;
              return addNotificationBlacklist("SMS", null);

            case 6:
              response = _context.sent;
              _context.next = 13;
              break;

            case 9:
              if (!notificationOption.currentTrade) {
                _context.next = 13;
                break;
              }

              _context.next = 12;
              return addNotificationBlacklist("SMS", maintradeId);

            case 12:
              response = _context.sent;

            case 13:
              if (((_response = response) === null || _response === void 0 ? void 0 : (_response$data = _response.data) === null || _response$data === void 0 ? void 0 : (_response$data$errors = _response$data.errors) === null || _response$data$errors === void 0 ? void 0 : _response$data$errors.code) === AccountErrorCode.ALREADY_EXISTS && ((_response2 = response) === null || _response2 === void 0 ? void 0 : (_response2$data = _response2.data) === null || _response2$data === void 0 ? void 0 : _response2$data.errors) > 0) {
                setAlertMessages({
                  title: intl.formatMessage(errorMessage.saveError),
                  description: intl.formatMessage(errorMessage.notificationsAlreadyDisabled)
                });
                setShowAlert(true);
              }

              setNotificactionOptionOld(notificationOption);
              setIsEditing(false);
              _context.next = 21;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](2);
              setShowAlert(true);

            case 21:
              _context.prev = 21;
              setLoading(false);
              return _context.finish(21);

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 18, 21, 24]]);
    }));

    return function handleAddToBlacklist() {
      return _ref.apply(this, arguments);
    };
  }();

  var handleRemoveFromBlacklist = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _user$currentTrade2;

      var maintradeId, response, _response3, _response3$data, _response3$data$error, _response4, _response4$data;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              maintradeId = +atob(user === null || user === void 0 ? void 0 : (_user$currentTrade2 = user.currentTrade) === null || _user$currentTrade2 === void 0 ? void 0 : _user$currentTrade2.idMainTrade).split(":")[1];
              _context2.prev = 2;

              if (!(!notificationOption.allTrades && notificationOptionOld.allTrades)) {
                _context2.next = 9;
                break;
              }

              _context2.next = 6;
              return removeNotificationBlacklist("SMS", null);

            case 6:
              response = _context2.sent;
              _context2.next = 13;
              break;

            case 9:
              if (!(!notificationOption.currentTrade && notificationOptionOld.currentTrade)) {
                _context2.next = 13;
                break;
              }

              _context2.next = 12;
              return removeNotificationBlacklist("SMS", maintradeId);

            case 12:
              response = _context2.sent;

            case 13:
              if (((_response3 = response) === null || _response3 === void 0 ? void 0 : (_response3$data = _response3.data) === null || _response3$data === void 0 ? void 0 : (_response3$data$error = _response3$data.errors) === null || _response3$data$error === void 0 ? void 0 : _response3$data$error.code) === AccountErrorCode.NOT_FOUND && ((_response4 = response) === null || _response4 === void 0 ? void 0 : (_response4$data = _response4.data) === null || _response4$data === void 0 ? void 0 : _response4$data.errors) > 0) {
                setAlertMessages({
                  title: intl.formatMessage(errorMessage.userAlreadyReceivingNotifications),
                  description: intl.formatMessage(errorMessage.notificationsAlreadyEnabled)
                });
                setShowAlert(true);
              }

              setNotificactionOptionOld(notificationOption);
              setIsEditing(false);
              _context2.next = 21;
              break;

            case 18:
              _context2.prev = 18;
              _context2.t0 = _context2["catch"](2);
              setShowAlert(true);

            case 21:
              _context2.prev = 21;
              setLoading(false);
              return _context2.finish(21);

            case 24:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 18, 21, 24]]);
    }));

    return function handleRemoveFromBlacklist() {
      return _ref2.apply(this, arguments);
    };
  }();

  React.useEffect(function () {
    var _location$state;

    if (((_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.from) === "account") {
      setIsEditing(true);
      myComponentRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  }, []);
  React.useEffect(function () {
    var _user$notificationBla;

    if (user && (user === null || user === void 0 ? void 0 : (_user$notificationBla = user.notificationBlacklistToCurrentMaintrade) === null || _user$notificationBla === void 0 ? void 0 : _user$notificationBla.length) > 0 && (user === null || user === void 0 ? void 0 : user.notificationBlacklistToCurrentMaintrade) !== null && (user === null || user === void 0 ? void 0 : user.notificationBlacklistToCurrentMaintrade) !== undefined) {
      var blackListEntry = user === null || user === void 0 ? void 0 : user.notificationBlacklistToCurrentMaintrade[0];

      if ((blackListEntry === null || blackListEntry === void 0 ? void 0 : blackListEntry.maintrade) !== undefined) {
        var _blackListEntry$maint, _blackListEntry$maint2;

        var isAllTrades = (blackListEntry === null || blackListEntry === void 0 ? void 0 : blackListEntry.maintrade) === null;
        var isCurrentTrade = false;

        if ((blackListEntry === null || blackListEntry === void 0 ? void 0 : blackListEntry.maintrade) !== null && (blackListEntry === null || blackListEntry === void 0 ? void 0 : (_blackListEntry$maint = blackListEntry.maintrade) === null || _blackListEntry$maint === void 0 ? void 0 : _blackListEntry$maint.id) !== undefined && (blackListEntry === null || blackListEntry === void 0 ? void 0 : (_blackListEntry$maint2 = blackListEntry.maintrade) === null || _blackListEntry$maint2 === void 0 ? void 0 : _blackListEntry$maint2.id)) {
          var _atob, _blackListEntry$maint3;

          var decodedId = (_atob = atob(blackListEntry === null || blackListEntry === void 0 ? void 0 : (_blackListEntry$maint3 = blackListEntry.maintrade) === null || _blackListEntry$maint3 === void 0 ? void 0 : _blackListEntry$maint3.id)) === null || _atob === void 0 ? void 0 : _atob.split(":")[1];
          isCurrentTrade = !!decodedId;
        }

        setNotificactionOptionOld({
          allTrades: isAllTrades,
          currentTrade: isCurrentTrade
        });
        setNotificactionOption({
          allTrades: isAllTrades,
          currentTrade: isCurrentTrade
        });
      }
    }
  }, [user]);
  return React.createElement(React.Fragment, null, React.createElement(S.Content, {
    className: classNames({
      notificationAlert: ((_location$state2 = location.state) === null || _location$state2 === void 0 ? void 0 : _location$state2.from) === "account"
    }),
    ref: myComponentRef
  }, React.createElement(S.HeaderSmall, null, !isEditing ? React.createElement(React.Fragment, null, React.createElement("h2", null, intl.formatMessage(settingsMessages.advertisingNotification)), React.createElement(IconButton, {
    testingContext: "editDetailsButton",
    name: "edit",
    size: 22,
    onClick: function onClick() {
      return setIsEditing(function (isEditing) {
        return !isEditing;
      });
    }
  })) : React.createElement(S.HeaderSmallPersonal, null, React.createElement("h2", null, intl.formatMessage(settingsMessages.advertisingNotification)))), React.createElement("div", null, React.createElement("p", {
    className: "notificationSubtitle"
  }, intl.formatMessage(settingsMessages.selectWhereToBlockNotifications)), React.createElement("div", null, React.createElement("div", {
    className: "checkboxContainer"
  }, React.createElement("input", {
    type: "checkbox",
    checked: notificationOption.currentTrade,
    onChange: function onChange(e) {
      if (e.target.checked) {
        setNotificactionOption({
          currentTrade: true,
          allTrades: false
        });
      } else {
        setNotificactionOption(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, {
            currentTrade: false
          });
        });
      }
    },
    disabled: !isEditing
  }), React.createElement("span", {
    className: "checkboxLabel"
  }, "".concat(intl.formatMessage(settingsMessages.doNotWantToReceiveNotificationsFrom), " "), user === null || user === void 0 ? void 0 : (_user$currentTrade3 = user.currentTrade) === null || _user$currentTrade3 === void 0 ? void 0 : _user$currentTrade3.nameMainTrade)), React.createElement("div", {
    className: "checkboxContainer"
  }, React.createElement("input", {
    type: "checkbox",
    checked: notificationOption.allTrades,
    onChange: function onChange(e) {
      if (e.target.checked) {
        setNotificactionOption({
          allTrades: true,
          currentTrade: false
        });
      } else {
        setNotificactionOption(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, {
            allTrades: false
          });
        });
      }
    },
    disabled: !isEditing
  }), React.createElement("span", {
    className: "checkboxLabel"
  }, intl.formatMessage(settingsMessages.doNotWantToReceiveNotificationsFromAnyEasyPedidoBusiness))))), isEditing && React.createElement("div", {
    className: "notificationFooter"
  }, React.createElement("button", {
    className: "buttonCancel",
    onClick: function onClick() {
      setNotificactionOption(notificationOptionOld);
      setIsEditing(false);
    }
  }, React.createElement("p", {
    className: "buttonText"
  }, intl.formatMessage(commonMessages.cancel))), !isEqual(notificationOption, notificationOptionOld) && Object.values(notificationOption).every(function (value) {
    return value === false;
  }) ? React.createElement("button", {
    className: "buttonApplyOld",
    onClick: handleRemoveFromBlacklist
  }, React.createElement("p", {
    className: "buttonText"
  }, intl.formatMessage(settingsMessages.receiveNotifications))) : React.createElement("button", {
    className: classNames("buttonApply", {
      buttonApplyDisabled: Object.values(notificationOption).every(function (value) {
        return value === false;
      }) || isEqual(notificationOption, notificationOptionOld)
    }),
    onClick: handleAddToBlacklist,
    disabled: Object.values(notificationOption).every(function (value) {
      return value === false;
    }) || isEqual(notificationOption, notificationOptionOld)
  }, React.createElement("p", {
    className: "buttonText"
  }, intl.formatMessage(settingsMessages.unsubscribe))))), loading && React.createElement(S.Loader, null, React.createElement(Loader, null)), showAlert && React.createElement(AlertReusableDialog, {
    hideModal: function hideModal() {
      setShowAlert(false);
    },
    AlertTitle: alertMessages.title,
    AlertDescription: alertMessages.description
  }));
};